import React from "react";
import Home from "../../components/Paginas/Home/Home";

const HomePage = () => {
  return <Home/>
};

export default HomePage;